
(function(){
  document.querySelectorAll('variant-picker').forEach(function(vp){
    vp.addEventListener('change', function(e){
      var el = e.target;
      if (el && el.matches('input[data-variant-id], select') && el.dataset && el.dataset.variantId){
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: { id: Number(el.dataset.variantId) } }
        }));
      }
    }, true);

    var idInput = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (idInput){
      if (idInput.value) {
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: { id: Number(idInput.value) } }
        }));
      }
      new MutationObserver(function(){
        if (idInput.value) {
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: { id: Number(idInput.value) } }
          }));
        }
      }).observe(idInput, { attributes: true, attributeFilter: ['value'] });

      idInput.addEventListener('change', function(ev){
        if (ev.target && ev.target.value) {
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: { variant: { id: Number(ev.target.value) } }
          }));
        }
      });
    }
  });
})();
(function VariantBridge(){
  const host = (document.currentScript && document.currentScript.closest('[data-dynamic-variant-content]')) || document;
  const form = host.querySelector('form.js-product-form, form[action="/cart/add"]') || document.querySelector('form.js-product-form, form[action="/cart/add"]');
  const pickerRoot = host.querySelector('variant-picker') || form || host;
  if (!form || !pickerRoot) return;
  if (pickerRoot.dataset.bridgeBound) return; 
  pickerRoot.dataset.bridgeBound = '1';

  let lastSentId = null;

  function getCurrentVariantId(){
    const el = form.querySelector('[name="id"]');
    const val = el && el.value;
    const id = Number(val);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  function emitIfChanged(force){
    const id = getCurrentVariantId();
    if (!id) return;
    if (force || id !== lastSentId){
      lastSentId = id;
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: { id }}}));
    }
  }

  ['variant:changed','product:variant-change','theme:variant:change'].forEach(evt=>{
    document.addEventListener(evt, ()=> setTimeout(emitIfChanged, 0), true);
  });

  pickerRoot.addEventListener('change', ()=> setTimeout(emitIfChanged, 0), true);
  pickerRoot.addEventListener('input',  ()=> setTimeout(emitIfChanged, 0), true);

  document.addEventListener('click', (e)=>{
    if (e.target.closest('label[for]') || e.target.closest('[data-option-position]') || e.target.closest('[data-option-name]')) {
      setTimeout(emitIfChanged, 0);
    }
  }, true);

  let pollTimer = null, pollStopTimer = null;
  function armPoll(){
    clearInterval(pollTimer); clearTimeout(pollStopTimer);
    pollTimer = setInterval(emitIfChanged, 120);
    pollStopTimer = setTimeout(()=>{ clearInterval(pollTimer); }, 2000);
  }
  pickerRoot.addEventListener('change', armPoll, true);
  document.addEventListener('click', armPoll, true);

  emitIfChanged(true);

  document.addEventListener('shopify:section:load', VariantBridge, { once: true });
})();